import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import AudioPromise from '@ivy/fts/audioPromise';
import { env } from '@ivy/fts/envInfo/envInfo';
import { getPublicParams, convertPxToVw } from '../../utils';
import * as _ from 'underscore';
let Album = class Album extends Vue {
    constructor() {
        super(...arguments);
        this.currentAudio = {};
        this.vip_config = null;
        this.sale_config = null;
        this.emptyAlbum = [
            {
                id: 'empty',
                play_count: 0,
                duration: 0,
                pic_url: require('../../images/pic-two.png'),
                title: '专辑名称专辑名称，最多显示2行 专辑名称专辑名称，最多显示2行',
                introduction: '专辑描述最多显示1行',
            },
        ];
        this.publishedAlbums = [];
        this.publicParams = {};
    }
    async getPubAlbums() {
        if (this.config && this.config.vip_config) {
            this.vip_config = this.config.vip_config;
        }
        if (this.config && this.config.sale_config) {
            this.sale_config = this.config.sale_config;
        }
        if (this.data.albums.length > 0) {
            let albumIds = this.data.albums
                .filter(item => !item._type || item._type === 'album')
                .map(t => t.id);
            let big_albumIds = this.data.albums
                .filter(item => item._type === 'big_album')
                .map(t => t.id);
            Promise.all([
                albumIds.length > 0
                    ? this.$axios
                        .post('/api/audios/resource/album/albumsById', {
                        ids: albumIds,
                    })
                        .then(res => res.data)
                    : [],
                big_albumIds.length > 0
                    ? this.$axios
                        .post('/api/audios/resource/bigAlbum/albumsById', {
                        ids: big_albumIds,
                    })
                        .then(res => res.data)
                    : [],
            ]).then(re => {
                const albumMapper = _.indexBy(re[0], 'id');
                const bigAlbumMapper = _.indexBy(re[1], 'id');
                let data = [];
                for (let i = 0; i < this.data.albums.length; i++) {
                    let item = null;
                    let baseItem = this.data.albums[i];
                    if (!baseItem._type || baseItem._type === 'album') {
                        if (!re[0].length)
                            break;
                        item = albumMapper[baseItem.id];
                    }
                    else if (baseItem._type === 'big_album') {
                        if (!re[1].length)
                            break;
                        item = bigAlbumMapper[baseItem.id];
                    }
                    if (item) {
                        if (!item.type) {
                            item.type = baseItem._type;
                        }
                        data.push(item);
                    }
                }
                this.publishedAlbums = data;
            });
        }
        else {
            this.publishedAlbums = [];
        }
    }
    async created() {
        this.publicParams = await getPublicParams(env);
        this.getPubAlbums();
    }
    get getClass() {
        if (this.canShowWhite && this.data.whiteCard) {
            return 'white-card';
        }
        else {
            return '';
        }
    }
    get noticeStyle() {
        return `background: ${this.vip_config.back_color};
           color:${this.vip_config.font_color};
           border-radius: 0px ${this.data.radius}px 0px 10px`;
    }
    get saleTipStyle() {
        return `background: ${this.sale_config.back_color};
           color:${this.sale_config.font_color};
           border-radius: 0px ${this.data.radius}px 0px 10px`;
    }
    get albumsBoxStyle() {
        return {
            'background-color': this.data.bgColor,
            padding: `0 ${convertPxToVw(this.data.compMargin)}vw`,
            'margin-left': `-${convertPxToVw(this.data.spacing / 2)}vw`,
            'margin-right': `-${convertPxToVw(this.data.spacing / 2)}vw`,
        };
    }
    get whiteStyle() {
        if (this.canShowWhite) {
            return {
                background: this.data.whiteCard ? '#fff' : '#f5f5f6',
                padding: '5px',
                paddingTop: '10px',
            };
        }
        return {};
    }
    get canShowWhite() {
        return this.data.lineRule === 'three';
    }
    get albumBoxStyle() {
        if (this.canShowWhite) {
            if (this.data.whiteCard) {
                return {
                    margin: `${convertPxToVw(this.data.spacing / 2)}vw`,
                    'border-radius': this.data.radius + 'px',
                    background: '#fff',
                    padding: '5px',
                };
            }
            else {
                return {
                    margin: `${convertPxToVw(this.data.spacing / 2)}vw`,
                    'border-radius': this.data.radius + 'px',
                    background: this.data.bgColor || '#f5f6f6',
                    padding: '0px',
                };
            }
        }
        else {
            return {
                margin: `${convertPxToVw(this.data.spacing / 2)}vw`,
                'border-radius': this.data.radius + 'px',
                background: this.data.lineRule === 'one'
                    ? '#fff'
                    : this.data.bgColor || '#f5f6f6',
            };
        }
        // return {
        //   'border-radius': this.data.radius + 'px',
        //   margin: `${convertPxToVw(this.data.spacing / 2)}vw`,
        // }
    }
    get playCountStyle() {
        return {
            left: this.data.whiteCard ? '5px' : '0px',
        };
    }
    get albumWrapperStyle() {
        return {
            'background-color': this.data.bgColor,
            padding: `0 ${convertPxToVw(this.data.compMargin)}vw`,
        };
    }
    get albumItemStyle() {
        return {
            margin: `${convertPxToVw(this.data.spacing / 2)}vw 0`,
            'border-radius': this.data.radius + 'px',
        };
    }
    get albumItemStyle3() {
        return {
            width: `calc(33.33% - ${this.data.spacing}px)`,
            margin: `${convertPxToVw(this.data.spacing / 2)}vw`,
            'border-radius': this.data.radius + 'px',
        };
    }
    get audioInfoStyle() {
        return {
            margin: `${convertPxToVw(this.data.spacing / 2)}vw 0`,
        };
    }
    get coverStyle() {
        return {
            'border-radius': this.data.radius + 'px',
            'object-fit': this.data.filling,
        };
    }
    get textStyle() {
        return {
            'text-align': this.data.fontAlign,
            'font-weight': this.data.fontWeight,
        };
    }
    get textDescStyle() {
        return {
            'text-align': this.data.fontAlign,
        };
    }
    get audioItemStyle() {
        return {
            margin: `${convertPxToVw(this.data.spacing / 2)}vw 0`,
            'border-radius': this.data.radius + 'px',
        };
    }
    get hasAlbum() {
        return this.data.albums && this.data.albums.length;
    }
    get albumList() {
        return this.hasAlbum ? this.publishedAlbums : this.emptyAlbum;
    }
    get showAlbumDesc() {
        return this.data.showAlbumDesc;
    }
    get showAlbumPlayCount() {
        return this.data.showAlbumPlayCount;
    }
    get showAudioDesc() {
        return this.data.showAudioDesc;
    }
    formatPlayCount(data) {
        let count = data.play_count || 1000;
        if (+count >= 100000000)
            return `${(+count / 100000000).toFixed(1)}亿播放`;
        if (+count >= 10000)
            return `${(+count / 10000).toFixed(1)}万播放`;
        return count || 0;
    }
    playInPage(audio) {
        if (!audio || !audio.audio_address)
            return;
        if (!this.audioComp) {
            this.audioComp = new AudioPromise(audio.audio_address, this.updateTime, this.updateStatus);
        }
        if (!this.currentAudio || this.currentAudio.audioId !== audio.id) {
            this.audioComp.info.src = audio.audio_address;
            this.currentAudio = {
                audioId: audio.id,
                position: 0,
                playing: false,
            };
        }
        if (this.currentAudio.playing) {
            this.currentAudio.playing = false;
            this.audioComp.pause();
        }
        else {
            this.currentAudio.playing = true;
            (this.currentAudio.audioId = audio.id),
                this.audioComp.play(this.currentAudio.position);
        }
    }
    updateTime(e) {
        this.$set(this.currentAudio, 'position', e.target.currentTime);
    }
    updateStatus(status) {
        if (status === 'ended') {
            this.currentAudio.playing = false;
            this.currentAudio = {};
        }
    }
    pauseInPage(audio) {
        this.audioComp.pause();
        this.currentAudio.playing = false;
        this.currentAudio = {};
    }
    async goAlbum(album) {
        // 微页面组件内容点击埋点
        await this.uploadEvent.sendRecord('Click_MicroPages_Component', '', {
            PageName: document.title,
            ComponentName: this.data.title,
            ContentName: album.title,
            JumpType: '专辑详情',
            JumpContentName: album.title,
            JumpContentID: album.id,
            isTabPage: +this.$route.query.isAppTab ? 'Y' : 'N',
        }, [
            ['p1', 'PageName'],
            ['p2', 'ComponentName_ContentName'],
            ['p3', 'isTabPage'],
            ['p4', 'JumpType_JumpContentID_JumpContentName'],
        ]);
        let conf;
        if (album.type == 'album') {
            conf = env.getParams('album', album.id);
        }
        else if (album.type == 'big_album') {
            conf = env.getParams('bigAlbum', album.id);
        }
        env.commonJump(conf.path, conf.params);
    }
};
tslib_1.__decorate([
    Prop()
], Album.prototype, "data", void 0);
tslib_1.__decorate([
    Prop()
], Album.prototype, "uploadEvent", void 0);
tslib_1.__decorate([
    Prop({ default: () => { } })
], Album.prototype, "config", void 0);
Album = tslib_1.__decorate([
    Component({})
], Album);
export default Album;
